<template>
    <app-main>
        <app-content>

             <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Pages"
                        sub-title="Editing a page"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right" v-if="!loading">
                    <app-button element="button" @click="composerOpened = ! composerOpened" class="btn btn--secondary btn--secondary--sml">Page Builder</app-button>
                </div>
            </div>

            <app-tabs-wrapper default="general" :loading="loading" :initial="loading" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="general" :handle-click="toggle" :active="active">General</app-tabs-trigger>
                    <app-tabs-trigger name="seo" :handle-click="toggle" :active="active">SEO &amp; Search</app-tabs-trigger>
                </div>

                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="general" :active="active">
                        <app-field-select
                            :required="true"
                            label="Locale"
                            :items="items.locales"
                            v-model="fields.locale_id"
                            disabled="true"
                            preselect="&mdash; Please select &mdash;"
                            :error="errors.locale_id"
                        />

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    :required="true"
                                    label="Title"
                                    v-model="fields.title"
                                    :error="errors.title"
                                />
                            </div>
                            <!-- <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="true"
                                    label="Slug"
                                    v-model="fields.slug"
                                    :error="errors.slug"
                                />
                            </div> -->
                        </div>

                        <app-field-toggle
                            :required="false"
                            label="Published?"
                            v-model="fields.published"
                            :error="errors.published"
                        />

                        <app-field-datetime
                            :required="false"
                            label="Published At"
                            v-if="fields.published"
                            v-model="fields.published_at"
                            :error="errors.published_at"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="seo" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-repeatable
                                    :required="false"
                                    label="Keywords (for searching)"
                                    placeholder="Enter a keyword"
                                    v-model="fields.keywords"
                                    :error="errors.keywords"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-repeatable
                                    :required="false"
                                    label="Phrases (for searching)"
                                    placeholder="Enter a phrase"
                                    v-model="fields.phrases"
                                    :error="errors.phrases"
                                />
                            </div>
                        </div>

                        <app-field-text
                            :required="false"
                            label="Meta Title"
                            v-model="fields.meta_title"
                            :error="errors.meta_title"
                        />

                        <app-field-textarea
                            :required="false"
                            label="Meta Description"
                            v-model="fields.meta_desc"
                            :error="errors.meta_desc"
                            rows="4"
                        />

                        <app-field-toggle
                            :required="false"
                            label="Enable no follow?"
                            v-model="fields.no_follow"
                            :error="errors.no_follow"
                        />

                        <app-field-toggle
                            :required="false"
                            label="Enable no index?"
                            v-model="fields.no_index"
                            :error="errors.no_index"
                        />
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>

            <!-- <div slot="footer"> -->
                <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                    Save
                </app-button>

                <app-button
                  element="a"
                  class="btn  btn--secondary  btn--secondary--sml ml-4"
                  @click="$router.push({ name: 'pages.home', query: { page: $route.params.page ? $route.params.page : 1, search: $route.params.search ? $route.params.search : '' } })"
                >
                    Cancel
                </app-button>
            <!-- </div> -->

            <!-- Start Builder -->
            <app-builder
                v-if="composerOpened"
                :saved="fields.builder"
                :locale="fields.locale_id"
                @save="updateContent"
            />
            <!-- End Builder -->

        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import RepeatableField from '@/components/fields/inputs/Repeatable';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';

    /* Builder components */
    import Builder from '@/components/composer/Builder';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'pages.edit',

        data: () => ({
            composerOpened: false,
            page: null,
            fields: {
                locale_id: 1,
                title: '',
                slug: '',
                keywords: [],
                phrases: [],
                meta_title: '',
                meta_desc: '',
                builder: '',
                no_follow: false,
                no_index: false,
                published: false,
                published_at: '',
            },
            items: {
                locales: []
            },
            loading: true,
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-builder': Builder,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-repeatable': RepeatableField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            if (typeof this.$route.params.id != 'undefined') {
                this.loading = true;

                this.getPage(this.$route.params.id)
                    .then(response => {
                        this.loading = false;

                        this.setLocales();

                        this.fields.locale_id = this.page.locale_id;
                        this.fields.title = this.page.title;
                        this.fields.slug  = this.page.slug;
                        this.fields.keywords = this.page.keywords;
                        this.fields.phrases = this.page.phrases;
                        this.fields.meta_title = this.page.meta_title;
                        this.fields.meta_desc = this.page.meta_desc;
                        this.fields.builder = this.page.builder;
                        this.fields.published = this.page.published;
                        this.fields.no_index = this.page.no_index;
                        this.fields.no_follow = this.page.no_follow;
                        this.fields.published_at = this.page.published_at.split(' ').join('T') + '.000Z';
                    })
                    .catch(response => {
                        this.$router.push({name: 'pages.home'});
                    });
            } else {
                this.$router.push({name: 'pages.home'});
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },

        methods: {
            getPage(id) {
                return Api.request('get', `pages/edit/${id}`)
                    .then(({ data }) => {
                        this.page = data.page;
                    });
            },
            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `pages/update/${this.page.id}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'pages.home',
                            query: {
                                page: this.$route.params.page ? this.$route.params.page : 1,
                                search: this.$route.params.search ? this.$route.params.search : ''
                            }
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
            updateContent(data) {
                this.fields.builder = data;

                this.composerOpened = ! this.composerOpened;
            },
            setLocales() {
                if (this.locales.length > 0) {
                    this.locales.forEach(locale => {
                        this.items.locales.push({
                            label: locale.lang,
                            value: locale.id
                        });
                    });
                }
            }
        },

        watch: {
            // 'fields.title': {
            //     handler(val) {
            //         this.fields.slug = val.toString().toLowerCase()
            //             .replace(/\s+/g, '-')           // Replace spaces with -
            //             .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            //             .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            //             .replace(/^-+/, '')             // Trim - from start of text
            //             .replace(/-+$/, '');            // Trim - from end of text
            //     }
            // }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/pages/Edit.vue